import React, { useState, useEffect, useRef } from 'react'
import { Form, notification, Col, Row, Button, Modal } from 'antd'
import { useDispatch } from 'react-redux'
import {
  displayDate, displayTime, fixed2Digit,
  InputBox,
  numberIntoWords
} from '../../../components/_utils/appUtils'
import GetEachFormFields from '../../../components/_utils/appFormUtils'
import AgentTypeheadComponent from '../../../components/_utils/AgentTypeheadComponent'
import {
  addXTravelTransferFxn,
  addXTravelTransferOtpFxn,
  getSingleUserFxn, listAllTransferFunctionFxn
} from '../actions'
import { TableComp } from 'sz-react-utils-lite'

const XTravelTransfer = (props) => {
  const { form: { getFieldDecorator, getFieldValue } } = props
  const tableAppRef = useRef()

  const dispatch = useDispatch()
  let [agentId, setAgentId] = useState('')
  let [agentData, setAgentData] = useState('')
  let [visibleOtpScreen, setVisibleOtpScreen] = useState(false)
  let [otp, setOtp] = useState('')
  const [totalApplication, setTotalApplication] = useState(0)

  const reloadTable = () => {
    tableAppRef.current.reload()
  }
  let apiRequest = params => {
    return new Promise(async resolve => {
      params = { ...params, agentId: agentId }
      if (!params.results) {
        params.results = 50
        params.count = 50
      }
      let resp = await dispatch(listAllTransferFunctionFxn({
        ...params, regExFilters: ['name']
      }))
      setTotalApplication(resp.total)
      resolve(resp)
    })
  }

  const columns = [
    {
      key: '_id',
      title: '#',
      dataIndex: '_id',
      width: 50,
      render: (item, record, index) => {
        return (
          <>
            {(index + 1)}
          </>
        )
      }
    },

    {
      title: 'Transaction Type',
      key: 'transactionType',
      dataIndex: 'transactionType',
      width: 150,
      render: (item, record) => {
        return (
          <div>
            <label className={'label label-tag-new label-sm'}>{item}</label>
          </div>
        )
      }
    },
    {
      title: 'Date',
      key: 'date',
      dataIndex: 'date',
      width: 150,
      render: (item, record) => {
        return (
          <>
            {displayDate(item)}, {displayTime(item)}
          </>
        )
      }
    },
    {
      title: 'Credit',
      width: 150,
      dataIndex: 'amount',
      key: 'credit',
      render: (item, record) => {
        let { transactionType } = record
        return (
          transactionType == 'Credit' ? <label className={'label label-success-green label-sm'}>
            Rs. {item}
          </label> : null
        )
      }
    },
    {
      title: 'Debit',
      width: 150,
      dataIndex: 'amount',
      key: 'debit',
      render: (item, record) => {
        let { transactionType } = record
        return (
          transactionType == 'Debit' ? <label className={'label label-danger label-sm'}>
            Rs. {item}
          </label> : null
        )
      }
    }
  ]

  const handleSubmitOtpFxn = async (e) => {
    const { form } = props
    e.preventDefault()
    try {
      const valData = await form.validateFields()
      if (!agentId) {
        notification.warning({ message: 'Please Choose Agent' })
        return
      }
      if (valData.amount && valData.amount <= 0) {
        notification.warning({ message: 'Please Enter Amount Greater Then 0' })
        return
      }
      valData.agentId = agentId
      const data = await dispatch(addXTravelTransferOtpFxn(valData))
      if (data && data.success) {
        setVisibleOtpScreen(true)
      }
    } catch (err) {
      notification.warning({
        message: 'Fill All Required Fields'
      })
    }
  }

  const handleSubmitFxn = async (e) => {
    const { form } = props
    e.preventDefault()
    try {
      const valData = await form.validateFields()
      if (!agentId) {
        notification.warning({ message: 'Please Choose Agent' })
        return
      }
      if (valData.amount && valData.amount <= 0) {
        notification.warning({ message: 'Please Enter Amount Greater Then 0' })
        return
      }
      const txnType = valData.transactionType
      const balance = Number(agentData || 0)
   /*   if (txnType === 'Debit' && valData.amount > balance) {
        notification.error({ message: 'Amount cannot exceed agent balance' })
        return
      }*/
      valData.agentId = agentId
      valData.otp = otp
      valData.transactionType = valData.transactionType
      const data = await dispatch(addXTravelTransferFxn(valData))
      if (data.success) {
        setVisibleOtpScreen(false)
        setOtp('')
        form.resetFields()
        reloadTable()
        getSingleUserData(agentId)
      }
    } catch (err) {
      notification.warning({
        message: 'Fill All Required Fields'
      })
    }
  }

  const getSingleUserData = async (agentId) => {
    let valData = {}
    valData.id = agentId
    const singleUserData = await dispatch(getSingleUserFxn(valData))
    if (singleUserData) {
      setAgentData(singleUserData.xTravelWallet)
    }
  }

  useEffect(() => {
    if (agentId) {
      getSingleUserData(agentId)
      reloadTable()
    }
  }, [agentId])

  const inputTypes = {
    fields: [
      {
        label: 'Agent',
        required: true,
        customField: (
          <>
            <InputBox title='* Agent' className='rowFlex' customStyle={{ marginTop: 10 }}>
              <div>
                <AgentTypeheadComponent
                  key={agentId}
                  agentId={agentId}
                  dispatch={dispatch}
                  customStyle=''
                  onSelect={item => setAgentId(item)}
                  blockStatus={false}
                />
              </div>
            </InputBox>
            <div>
              {(agentId && agentData) ? (
                <div style={{ fontWeight: 'bold', color: '#4CAF50' }}>
                  Agent Current Balance: Rs. {fixed2Digit(agentData) || 0}
                </div>
              ) : null}
            </div>
          </>
        )
      },
      {
        key: 'transactionType',
        label: 'Transaction Type',
        required: true,
        type: 'select',
        showSearch: false,
        options: [
          { label: 'Add', value: 'Credit' },
          { label: 'Deduct', value: 'Debit' }
        ],
        keyAccessor: x => x.value,
        valueAccessor: x => x.label,
        onChange: x => {
          props.form.setFieldsValue({
            transactionType: x
          })
        }
      },
      {
        key: 'amount',
        label: 'Transfer Amount',
        required: true,
        type: 'number',
        placeholder: 'Amount',
        extra: `Amount in Words - ${getFieldValue('amount') ? numberIntoWords(getFieldValue('amount')) : 'Please Enter Transfer Amount'}`,
        rules: [
          {
            validator: (_, value, callback) => {
              const type = getFieldValue('transactionType')
              if (type === 'Debit' && value > agentData) {
                return callback('Amount cannot be greater than agent balance.')
              }
              return callback()
            }
          }
        ]
      }
    ]
  }
  const formItemLayout = {
    labelCol: {
      xs: { span: 0 },
      sm: { span: 0 },
      md: { span: 0 }
    },
    wrapperCol: {
      xs: { span: 24 },
      sm: { span: 24 },
      md: { span: 24 }
    }
  }

  return (
    <>
      <div className='row mt-4'>
        <div className='col-lg-4'>
          <div className='form-box'>
            <div className='d-flex align-items-center mb-3 heading-form'>
              <h5>Transfer Amount To XTravelWorld Wallet</h5>
            </div>
            <div className='card unizportal'>
              <Form>
                <Row gutter={24}>
                  {inputTypes.fields.map((item, key) => {
                    return (
                      <>
                        {item.customField ?
                          <Col span={24}>
                            {item.customField}
                          </Col> :
                          <Col span={24} key={key}>
                            <GetEachFormFields
                              item={{ ...item, rules: item.rules }}
                              getFieldDecorator={getFieldDecorator}
                              formItemLayout={formItemLayout} />
                          </Col>}
                      </>
                    )
                  })}
                </Row>
                <button className='btn' type='submit' onClick={handleSubmitOtpFxn}>Save</button>
              </Form>
            </div>
          </div>
        </div>
        <div className='col-lg-8' key={agentId}>
          <React.Fragment>
            <div className='d-flex align-items-center mb-3 heading-form'>
              <h5 className={'w-50'}>All XTravelWorld Transfers ( Total : {totalApplication} )</h5>
              <div className='sort-box-table mark-btn alignRight w-50'>
                {(agentId && agentData) ? (
                  <span>
                    Agent Current Balance: <b>Rs. {fixed2Digit(agentData) || 0}</b>
                  </span>
                ) : null}
              </div>

            </div>
            <div className='card'>
              <div className='card-body table-responsive'>
                <TableComp
                  columns={columns}
                  rowKey={(item, index) => {
                    return index
                  }}
                  apiRequest={apiRequest}
                  pagination={{
                    position: 'top',
                    pageSizeOptions: ['50', '100', '150', '200'],
                    defaultPageSize: 50
                  }}
                  ref={tableAppRef}
                />
              </div>
            </div>
          </React.Fragment>
        </div>
      </div>


      <Modal
        visible={visibleOtpScreen}
        closable={true}
        onCancel={() => {
          setVisibleOtpScreen(false)
        }}
        title={'Enter OTP'}
        footer={false}>
        <div style={{ textAlign: 'center', marginBottom: 10 }}>
          <h6>
            {' '}
            A text message with a 4-digit verification code has been sent to
            your phone number.
          </h6>
          <InputBox title={'Enter OTP'}>
            <input
              className={'form-control mt10'}
              type={'password'}
              minLength={4}
              maxLength={4}
              value={otp}
              onChange={({ target }) => {
                setOtp(target.value)
              }}
            />
          </InputBox>
          <Button
            className={'btn btn-success mt10'}
            onClick={handleSubmitFxn}>
            Submit OTP
          </Button>
        </div>
      </Modal>
    </>
  )
}


export default Form.create()(XTravelTransfer)
